/* Qalbeen · HOVER · fiches produit : galerie à glisser, variantes, quantité, option, barre collante,
   dates de livraison, cartes à retourner, carnet à feuilleter, bienfaits animés, filtres d'avis, onglets FAQ et vente croisée, vidéos.
   Chargé en defer par plusieurs sections : ne s'installe qu'une fois. Sans jQuery. */
(function () {
  if (window.HoverProduit) return;
  var D = document;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var $ = function (s, c) { return (c || D).querySelector(s); };
  var json = function (el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };

  /* ---------- galerie ---------- */
  function galerie(g) {
    if (g._hvp) return; g._hvp = 1;
    var tr = $('[data-hvp-track]', g); if (!tr) return;
    var items = $$('.hvp-gal__item', tr), dots = $$('.hvp-gal__dots i', g), th = $$('[data-hvp-thumb]', g), cnt = $('[data-hvp-i]', g);
    var cur = 0, tick = null;
    function maj(i) {
      if (i === cur && cnt && cnt.textContent == i + 1) return;
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      th.forEach(function (b, k) { b.classList.toggle('on', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      if (cnt) cnt.textContent = i + 1;
      items.forEach(function (it, k) { if (k !== i) { var v = $('video', it); if (v && !v.paused) v.pause(); } });
    }
    tr.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () { tick = null; var w = tr.clientWidth || 1; maj(Math.max(0, Math.min(items.length - 1, Math.round(tr.scrollLeft / w)))); });
    }, { passive: true });
    function aller(i) { i = (i + items.length) % items.length; tr.scrollTo({ left: i * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); maj(i); }
    g._aller = aller;
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hvp-thumb]'); if (t) { aller(+t.getAttribute('data-hvp-thumb')); return; }
      if (e.target.closest('[data-hvp-gal-prev]')) aller(cur - 1);
      if (e.target.closest('[data-hvp-gal-next]')) aller(cur + 1);
    });
    tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); aller(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); aller(cur - 1); } });
  }

  /* ---------- prix en devise de la cliente (seulement pour quantité > 1 : le prix unitaire vient de Liquid) ---------- */
  function fmt(cents, cur) {
    try { return new Intl.NumberFormat(D.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + cur; }
  }

  /* nombre lu dans un prix affiché (« €24,90 », « 1 234,50 € », « $26.90 ») */
  function num(t) {
    t = (t || '').replace(/[^0-9.,]/g, ''); if (!t) return 0;
    var c = t.lastIndexOf(','), d = t.lastIndexOf('.'), dec = Math.max(c, d);
    if (dec > -1 && t.length - dec - 1 <= 2) t = t.slice(0, dec).replace(/[.,]/g, '') + '.' + t.slice(dec + 1); else t = t.replace(/[.,]/g, '');
    return parseFloat(t) || 0;
  }

  /* même présentation qu'un prix affiché par Shopify (« €24,90 »), avec un autre montant */
  function refait(modele, n) {
    var virg = /\d,\d{2}(?!\d)/.test(modele), x = n.toFixed(2);
    if (virg) x = x.replace('.', ',');
    return modele.replace(/\d[\d.,\s\u00a0\u202f]*\d/, x);
  }

  /* ---------- fiche ---------- */
  function fiche(s) {
    if (s._hvp) return; s._hvp = 1;
    var g = $('[data-hvp-gal]', s); if (g) galerie(g);
    var idIn = $('[data-hvp-id]', s), atc = $('[data-hvp-atc]', s), lab = $('[data-hvp-atc-label]', s), tot = $('[data-hvp-total]', s);
    var qty = $('[data-hvp-qty]', s), unit = json($('[data-hvp-unit]', s)) || { p: 0, c: 'EUR' };
    var variants = json($('[data-hvp-variants]', s)), sticky = $('[data-hvp-sticky-btn]', s);
    var txt = function (k) { var t = $('[data-hvp-txt-' + k + ']', s); return t ? t.innerHTML.trim() : ''; };
    var price = unit.p, firstTot = tot ? tot.innerHTML : '';

    function total() {
      if (!tot) return;
      var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      var base = D.createElement('span'); base.innerHTML = firstTot;
      tot.innerHTML = q > 1 ? (/\d/.test(base.textContent) ? refait(base.textContent.trim(), price * q / 100) : fmt(price * q, unit.c)) : firstTot;
    }

    /* variantes */
    if (variants && variants.length) {
      var radios = $$('[data-hvp-opt]', s);
      var choisir = function () {
        var sel = [];
        radios.forEach(function (r) { if (r.checked) sel[+r.getAttribute('data-hvp-opt')] = r.value; });
        var v = null;
        variants.forEach(function (x) { if (!v && x.o.every(function (o, i) { return sel[i] === undefined || o === sel[i]; })) v = x; });
        sel.forEach(function (val, i) { var b = $('[data-hvp-optval="' + i + '"]', s); if (b) b.textContent = val; });
        if (!v) { if (atc) { atc.disabled = true; if (lab) lab.innerHTML = txt('unavailable'); } if (sticky) sticky.disabled = true; return; }
        if (idIn) { idIn.value = v.id; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
        try { s.dispatchEvent(new CustomEvent('hvp:variant', { detail: { id: v.id } })); } catch (e) {} /* bloc « Offre » */
        var tl = $('[data-hvp-price-l="' + v.id + '"]', s), ts = $('[data-hvp-price-s="' + v.id + '"]', s);
        $$('[data-hvp-price-slot]', s).forEach(function (slot) {
          var big = slot.closest('.hvp-price'); var t = big ? tl : ts; if (t) { slot.innerHTML = t.innerHTML; slot.removeAttribute('data-k'); }
        });
        if (s._kPlan) s._kPlan();
        if (tot && tl) { var b = $('b', tl.content || tl); firstTot = b ? b.innerHTML : firstTot; }
        price = v.p; total();
        if (atc) { atc.disabled = !v.a; if (lab) lab.innerHTML = v.a ? txt('add') : txt('soldout'); }
        if (sticky) sticky.disabled = !v.a;
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        if (v.m && g && g._aller) { var its = $$('.hvp-gal__item', g); its.forEach(function (it, k) { if (+it.getAttribute('data-media-id') === v.m) g._aller(k); }); }
        /* états « épuisé » des pastilles */
        radios.forEach(function (r) {
          var i = +r.getAttribute('data-hvp-opt'), test = sel.slice(); test[i] = r.value;
          var ok = variants.some(function (x) { return x.a && x.o.every(function (o, k) { return test[k] === undefined || o === test[k]; }); });
          r.closest('.hvp-pill').classList.toggle('is-out', !ok);
        });
      };
      radios.forEach(function (r) { r.addEventListener('change', choisir); });
      choisir();
    }

    /* quantité */
    s.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hvp-q]'); if (!b || !qty) return;
      qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-hvp-q')))); total();
    });
    if (qty) qty.addEventListener('input', total);

    /* option (ajoutée juste avant le produit principal, à son prix) */
    var gift = $('[data-hvp-gift]', s), giftDone = false;
    if (gift && atc) atc.addEventListener('click', function (e) {
      if (!gift.checked || giftDone || s.classList.contains('hvp--kaching') || atc.disabled) return;
      e.preventDefault(); e.stopImmediatePropagation();
      atc.classList.add('loading');
      fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +gift.getAttribute('data-hvp-gift'), quantity: 1 }] }) })
        .catch(function () {}).then(function () { atc.classList.remove('loading'); giftDone = true; atc.click(); setTimeout(function () { giftDone = false; }, 1500); });
    }, true);

    /* barre collante : même bouton que la fiche (Kaching et le panier s'en occupent).
       En plus de hover.js (IntersectionObserver), un contrôle au défilement couvre les sauts d'ancre. */
    if (sticky) {
      sticky.addEventListener('click', function () { var b = D.getElementById(sticky.getAttribute('data-hvp-sticky-btn')); if (b && !b.disabled) b.click(); });
      var bar = sticky.closest('.hv-sticky'), cible = D.getElementById(sticky.getAttribute('data-hvp-sticky-btn')), rq = null;
      var verifie = function () { rq = null; if (!bar || !cible) return; var v = cible.getBoundingClientRect().bottom < 0; if (bar.classList.contains('on') !== v) { bar.classList.toggle('on', v); D.body.classList.toggle('hv-has-sticky', v); bar.setAttribute('aria-hidden', String(!v)); } };
      window.addEventListener('scroll', function () { if (!rq) rq = requestAnimationFrame(verifie); }, { passive: true });
      setTimeout(verifie, 300);
    }

    /* Kaching Bundles présent : il gère quantité, packs et prix du pack (remise appliquée au paiement).
       Le prix affiché dans le bouton et la barre collante devient celui du pack choisi, tel que Kaching l'affiche :
       c'est exactement le montant payé. */
    var kSync = function () {
      var blk = $('.kaching-bundles__block', s); if (!blk) return;
      s.classList.add('hvp--kaching');
      var BAR = '.kaching-bundles__bar:not(.kaching-bundles__checkbox-upsells__upsell)';
      var bar = $(BAR + '.kaching-bundles__bar--selected', blk) || $(BAR, blk); if (!bar) return;
      var p = $('.kaching-bundles__bar-price', bar), f = $('.kaching-bundles__bar-full-price', bar);
      var pt = p ? p.textContent.trim() : '', ft = f ? f.textContent.trim() : '';
      if (!pt) return;
      /* options cochées (pochons du pack, cases « 30 jours offerts »…) : ajoutées au total, comme au panier */
      var plus = 0, plusF = 0;
      $$('.kaching-bundles__upsell', bar).forEach(function (u) {
        if (!$('.kaching-bundles__upsell__checkbox--selected', u)) return;
        plus += num(($('.kaching-bundles__upsell__price', u) || {}).textContent); plusF += num(($('.kaching-bundles__upsell__full-price', u) || $('.kaching-bundles__upsell__price', u) || {}).textContent);
      });
      $$('.kaching-bundles__checkbox-upsells__upsell', blk).forEach(function (u) {
        var m = $('[aria-checked="true"]', u); if (!m) return;
        plus += num(($('.kaching-bundles__bar-price', u) || {}).textContent); plusF += num(($('.kaching-bundles__bar-full-price', u) || $('.kaching-bundles__bar-price', u) || {}).textContent);
      });
      if (plus > 0) { pt = refait(pt, num(pt) + plus); if (ft) ft = refait(ft, num(ft) + plusF); }
      var put = function (el, v) { if (el && el.textContent !== v) el.textContent = v; };
      put(tot, pt);
      /* prix en haut de fiche : celui de l'offre la moins chère (une seule unité), tel que Kaching le fera payer */
      var main = $('.hvp-price [data-hvp-price-slot]', s);
      if (main) {
        var best = null;
        $$(BAR, blk).forEach(function (br) {
          var bp = $('.kaching-bundles__bar-price', br), bf = $('.kaching-bundles__bar-full-price', br); if (!bp) return;
          var n = num(bp.textContent); if (n && (!best || n < best.n)) best = { n: n, p: bp.textContent.trim(), f: bf ? bf.textContent.trim() : '', fn: bf ? num(bf.textContent) : 0 };
        });
        if (best) {
          var bEl = $('.hv-price > b', main), sEl = $('.hv-price > s', main), sv = $('.hv-save', main);
          put(bEl, best.p);
          if (best.f) put(sEl, best.f);
          if (best.fn > best.n) put(sv, '−' + Math.round((best.fn - best.n) * 100 / best.fn) + ' %');
        }
      }
      var st = $('.hvp-sticky [data-hvp-price-slot]', s);
      if (st && st.getAttribute('data-k') !== pt + '|' + ft) {
        st.setAttribute('data-k', pt + '|' + ft);
        st.innerHTML = '<span class="hv-price"><b></b>' + (ft && ft !== pt ? '<s></s>' : '') + '</span>';
        $('b', st).textContent = pt; if ($('s', st)) $('s', st).textContent = ft;
      }
    };
    var kTimer = null, kPlan = function () { clearTimeout(kTimer); kTimer = setTimeout(kSync, 60); };
    s._kPlan = kPlan;
    kSync(); setTimeout(kSync, 1200); setTimeout(kSync, 3500);
    if ('MutationObserver' in window) new MutationObserver(kPlan).observe(s, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    s.addEventListener('change', kPlan); s.addEventListener('click', kPlan);
    total();
  }

  /* ---------- dates de livraison (fuseau de la boutique) ---------- */
  function partsTz(d, tz) {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, weekday: 'short' }).formatToParts(d), o = {};
      p.forEach(function (x) { o[x.type] = x.value; });
      return { y: +o.year, m: +o.month - 1, d: +o.day, h: +o.hour % 24 };
    } catch (e) { return { y: d.getFullYear(), m: d.getMonth(), d: d.getDate(), h: d.getHours() }; }
  }
  function dates(box) {
    if (box._hvp) return; box._hvp = 1;
    var tz = box.getAttribute('data-tz') || 'Europe/Paris', cut = +box.getAttribute('data-cutoff') || 11;
    var min = +box.getAttribute('data-min') || 1, max = +box.getAttribute('data-max') || min;
    var n = partsTz(new Date(), tz), base = new Date(Date.UTC(n.y, n.m, n.d, 12));
    var jour = function (d) { return d.getUTCDay(); }, plus = function (d, k) { return new Date(d.getTime() + k * 864e5); };
    var exp = base, meme = true;
    if (n.h >= cut) { exp = plus(exp, 1); meme = false; }
    while (jour(exp) === 0 || jour(exp) === 6) { exp = plus(exp, 1); meme = false; }
    var ajoute = function (d, k) { while (k > 0) { d = plus(d, 1); if (jour(d) !== 0) k--; } return d; };
    var dmin = ajoute(exp, min), dmax = ajoute(exp, max);
    var lang = D.documentElement.lang || 'fr';
    var f = function (d, o) { return new Intl.DateTimeFormat(lang, Object.assign({ timeZone: 'UTC' }, o)).format(d); };
    var longue = function (d) { return f(d, { weekday: 'long', day: 'numeric', month: 'long' }); };
    $$('[data-hvp-date]', box).forEach(function (el) {
      var k = el.getAttribute('data-hvp-date');
      if (k === 'ship') el.textContent = meme ? (el.getAttribute('data-today') || longue(exp)) : longue(exp);
      if (k === 'ship-sub') el.textContent = meme ? el.getAttribute('data-same') : el.getAttribute('data-next');
      if (k === 'ship-day') el.textContent = meme ? (el.getAttribute('data-today') || f(exp, { weekday: 'long' })) : f(exp, { weekday: 'long', day: 'numeric' });
      if (k === 'arrive-day') el.textContent = f(dmin, { weekday: 'long', day: 'numeric' });
      if (k === 'arrive') {
        if (box.getAttribute('data-mode') === 'range' && max > min) {
          var memeMois = dmin.getUTCMonth() === dmax.getUTCMonth();
          el.textContent = (el.getAttribute('data-between') || 'Entre le') + ' ' + (memeMois ? f(dmin, { weekday: 'long', day: 'numeric' }) : longue(dmin)) + ' ' + (el.getAttribute('data-and') || 'et le') + ' ' + longue(dmax);
        } else el.textContent = longue(dmin);
      }
    });
  }

  /* ---------- cartes à retourner ---------- */
  function paquet(deck) {
    if (deck._hvp) return; deck._hvp = 1;
    var cards = $$('[data-hvp-card]', deck).filter(function (c) { return c.getAttribute('data-hvp-card') !== 'end'; });
    var fin = $('[data-hvp-card="end"]', deck), live = deck.parentNode.querySelector('[data-hvp-deck-live]'), i = 0;
    function montre(k) {
      cards.concat(fin ? [fin] : []).forEach(function (c, j) {
        var on = (j === k); c.classList.toggle('cur', on); c.classList.toggle('out', j < k); c.setAttribute('aria-hidden', String(!on));
        if (c !== fin) c.setAttribute('tabindex', on ? '0' : '-1');
        if (!on) c.classList.remove('on');
      });
      i = k;
      var c = cards[k] || fin; if (c && D.activeElement && deck.contains(D.activeElement)) { var f = c === fin ? $('a,button', fin) : c; if (f) f.focus({ preventScroll: true }); }
    }
    function avance(c) {
      if (!c.classList.contains('on')) { c.classList.add('on'); if (live) live.textContent = ($('.hvp-face--2 q', c) || {}).textContent || ''; return; }
      if (i < cards.length - 1) montre(i + 1);
      else if (fin) montre(cards.length);
      else montre(0);
    }
    deck.addEventListener('click', function (e) {
      if (e.target.closest('[data-hvp-replay]')) { montre(0); return; }
      if (e.target.closest('a')) return;
      var c = e.target.closest('[data-hvp-card]'); if (c && c !== fin) avance(c);
    });
    deck.addEventListener('keydown', function (e) {
      var c = e.target.closest('[data-hvp-card]'); if (!c || c === fin) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); avance(c); }
    });
  }

  /* ---------- carnet à feuilleter (hover-prod-univers, blocs « Page ») ----------
     Double page sur un écran large (la couverture seule à droite, puis les pages deux par deux), une page à la fois sur téléphone.
     Une feuille tourne autour de la reliure : au toucher (droite = suivante, gauche = précédente), aux flèches, au clavier,
     ou en la faisant glisser du doigt (elle suit le doigt, puis finit de tourner ou retombe). */
  function livre(bk) {
    if (bk._hvp) return; bk._hvp = 1;
    var stage = $('[data-hvp-book-stage]', bk); if (!stage) return;
    var pages = $$('[data-hvp-pg]', stage).map(function (f) {
      var im = $('img', f), cap = $('figcaption', f);
      return { img: im, t: cap ? (($('b', cap) || {}).textContent || '') : '', x: cap ? (($('span', cap) || {}).textContent || '') : '' };
    }).filter(function (p) { return p.img; });
    var N = pages.length; if (!N) return;
    var capEl = $('[data-hvp-book-cap]', bk), prevB = $('[data-hvp-book-prev]', bk), nextB = $('[data-hvp-book-next]', bk);
    var mode = '', leaves = [], cur = 0, max = 0, busy = false;
    function face(p, cls) {
      var d = D.createElement('div'); d.className = 'hvp-book__f ' + cls;
      if (p) { var c = p.img.cloneNode(true); c.loading = 'eager'; c.removeAttribute('fetchpriority'); d.appendChild(c); } else d.classList.add('is-blank');
      return d;
    }
    function construire() {
      var m = stage.parentNode.clientWidth >= 620 ? 'double' : 'simple';
      if (m === mode) return;
      var page = mode === 'double' ? Math.max(0, cur * 2 - 1) : cur; /* garder la page lue */
      mode = m; bk.classList.toggle('is-double', m === 'double'); bk.classList.toggle('is-simple', m === 'simple');
      leaves.forEach(function (l) { l.remove(); }); leaves = [];
      var L = m === 'double' ? Math.ceil(N / 2) : N;
      for (var k = 0; k < L; k++) {
        var lf = D.createElement('div'); lf.className = 'hvp-book__leaf';
        if (m === 'double') { lf.appendChild(face(pages[2 * k], 'hvp-book__f--front')); lf.appendChild(face(pages[2 * k + 1], 'hvp-book__f--back')); }
        else { lf.appendChild(face(pages[k], 'hvp-book__f--front')); lf.appendChild(face(null, 'hvp-book__f--back')); }
        stage.appendChild(lf); leaves.push(lf);
      }
      max = m === 'double' ? (N % 2 ? L - 1 : L) : N - 1;
      cur = m === 'double' ? Math.min(max, Math.ceil(page / 2)) : Math.min(max, page);
      leaves.forEach(function (l, k) { l.classList.toggle('tourne', k < cur); });
      ordre(); legende();
    }
    function ordre(top) {
      var L = leaves.length;
      leaves.forEach(function (l, k) { l.style.zIndex = l === top ? L + 2 : (k < cur ? k + 1 : L - k + 1); });
    }
    function visibles() {
      if (mode === 'simple') return [cur];
      var g = cur * 2 - 1, d = cur * 2; return [g, d].filter(function (i) { return i >= 0 && i < N; });
    }
    function legende() {
      var v = visibles(), i = v[v.length - 1], p = pages[i] || {};
      if (capEl) capEl.innerHTML = '<b></b><span></span><em></em>';
      if (capEl) { $('b', capEl).textContent = p.t || ''; $('span', capEl).textContent = p.x || ''; $('em', capEl).textContent = v.map(function (x) { return x + 1; }).join('-') + ' / ' + N; }
      if (prevB) prevB.disabled = cur <= 0;
      if (nextB) nextB.disabled = cur >= max;
      bk.classList.toggle('is-debut', cur === 0); bk.classList.toggle('is-fin', cur >= max);
    }
    function tourner(dir) {
      if (busy) return;
      var k = dir > 0 ? cur : cur - 1;
      if (k < 0 || (dir > 0 && cur >= max)) return;
      var lf = leaves[k]; busy = true;
      ordre(lf); lf.style.transform = ''; lf.classList.add('anim');
      lf.classList.toggle('tourne', dir > 0);
      cur += dir; legende();
      setTimeout(function () { lf.classList.remove('anim'); ordre(); busy = false; }, reduce ? 20 : 820);
    }
    /* au doigt : la feuille suit le geste */
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      if (busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
      drag = { x: e.clientX, y: e.clientY, id: e.pointerId, lf: null, dir: 0, a: 0, moved: false };
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
        drag.dir = dx < 0 ? 1 : -1;
        var k = drag.dir > 0 ? cur : cur - 1;
        if (k < 0 || (drag.dir > 0 && cur >= max)) { drag = null; return; }
        drag.lf = leaves[k]; drag.moved = true; ordre(drag.lf); drag.lf.classList.add('drag');
        try { stage.setPointerCapture(e.pointerId); } catch (x) {}
      }
      var w = stage.clientWidth / (mode === 'double' ? 2 : 1) || 1;
      var a = drag.dir > 0 ? Math.max(-180, Math.min(0, dx / w * 180)) : Math.min(0, Math.max(-180, -180 + dx / w * 180));
      drag.a = a; drag.lf.style.transform = 'rotateY(' + a.toFixed(1) + 'deg)';
      e.preventDefault();
    });
    function lacher(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      if (!d.moved) return;
      d.lf.classList.remove('drag');
      var fini = d.dir > 0 ? d.a < -55 : d.a > -125;
      if (fini) { tourner(d.dir); }
      else { d.lf.classList.add('anim'); d.lf.style.transform = ''; setTimeout(function () { d.lf.classList.remove('anim'); ordre(); }, 500); }
      stage._drag = true; setTimeout(function () { stage._drag = false; }, 50);
    }
    stage.addEventListener('pointerup', lacher);
    stage.addEventListener('pointercancel', lacher);
    stage.addEventListener('click', function (e) {
      if (stage._drag) return;
      var r = stage.getBoundingClientRect(), x = e.clientX - r.left;
      tourner(x > r.width * (mode === 'double' ? 0.5 : 0.35) ? 1 : -1);
    });
    if (prevB) prevB.addEventListener('click', function () { tourner(-1); });
    if (nextB) nextB.addEventListener('click', function () { tourner(1); });
    bk.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); tourner(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); tourner(-1); }
    });
    construire();
    bk.classList.add('is-pret');
    if ('ResizeObserver' in window) new ResizeObserver(function () { construire(); }).observe(bk);
  }

  /* ---------- bienfaits animés (hover-prod-ba) : « sans » barré, « avec » qui s'ouvre, chiffre qui compte ---------- */
  function bienfaits(b) {
    if (b._hvp) return; b._hvp = 1;
    var big = $('[data-to]', b);
    function compte() {
      if (!big) return;
      var to = +big.getAttribute('data-to') || 0, t0 = null, dur = 1600;
      if (reduce || !to) { big.textContent = to || big.textContent; return; }
      big.textContent = '0';
      function pas(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3); big.textContent = String(Math.round(to * e)); if (p < 1) requestAnimationFrame(pas); }
      requestAnimationFrame(pas);
    }
    function go() { b.classList.add('vu'); var n = $$('.hvp-ba2__sans li', b).length; setTimeout(compte, reduce ? 0 : (n ? 900 + n * 450 : 500)); }
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { go(); return; }
    b.classList.add('is-js');
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); go(); } }); }, { threshold: .3 });
    io.observe(b);
  }

  /* ---------- avis : filtres et widget Vitals replié ---------- */
  function avis(sec) {
    if (sec._hvp) return; sec._hvp = 1;
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hvp-rfilter]');
      if (b) {
        var k = b.getAttribute('data-hvp-rfilter');
        $$('[data-hvp-rfilter]', sec).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        $$('.hvp-rev', sec).forEach(function (r) { r.hidden = !!k && r.getAttribute('data-t') !== k; });
      }
      var m = e.target.closest('[data-hvp-vitals-more]');
      if (m) { var v = $('[data-hvp-vitals]', sec); if (v) { v.classList.add('on'); m.setAttribute('aria-expanded', 'true'); m.parentNode.hidden = true; } }
    });
  }

  /* ---------- onglets (FAQ, vente croisée) ---------- */
  function onglets(sec, attr, panel) {
    if (sec['_hvp' + attr]) return; sec['_hvp' + attr] = 1;
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[' + attr + ']'); if (!b) return;
      var k = b.getAttribute(attr);
      $$('[' + attr + ']', sec).forEach(function (x) { var on = x === b; x.setAttribute('aria-pressed', String(on)); x.setAttribute('aria-selected', String(on)); });
      if (panel === 'faq') $$('details[data-t]', sec).forEach(function (d) { d.hidden = d.getAttribute('data-t') !== k; });
      else {
        $$('[data-hvp-xpanel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-hvp-xpanel') !== k; if (!p.hidden) p.scrollLeft = 0; });
        $$('[data-hvp-arrow]', sec).forEach(function (a) { a.setAttribute('data-hv-rail', '#' + sec.querySelector('[data-hvp-xpanel="' + k + '"]').id); });
      }
    });
  }

  /* ---------- recommandations Shopify ---------- */
  function reco(r) {
    if (r._hvp) return; r._hvp = 1;
    var url = r.getAttribute('data-hvp-reco'); if (!url || r.children.length) return;
    var go = function () {
      fetch(url).then(function (x) { return x.text(); }).then(function (h) {
        var d = D.createElement('div'); d.innerHTML = h;
        var n = d.querySelector('[data-hvp-reco]'); if (n && n.innerHTML.trim()) r.innerHTML = n.innerHTML; else r.closest('section').hidden = true;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '400px' }); io.observe(r); } else go();
  }

  /* ---------- vidéos ---------- */
  function videos(c) {
    $$('[data-hvp-vid]', c).forEach(function (w) {
      if (w._hvp) return; w._hvp = 1;
      var v = $('video', w), fig = w.closest('.hvp-vid'); if (!v) return;
      v.removeAttribute('controls');
      w.addEventListener('click', function () {
        if (v.paused) { $$('.hvp-vid video').forEach(function (o) { if (o !== v && !o.paused) { o.pause(); } }); v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); }); }
        else v.pause();
      });
      v.addEventListener('play', function () { fig.classList.add('on'); });
      v.addEventListener('pause', function () { fig.classList.remove('on'); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (!en[0].isIntersecting && !v.paused) v.pause(); }).observe(w);
    });
  }

  /* ---------- avis dans une fenêtre ----------
     La note du haut, la preuve sous le bouton et « Voir tous les avis » ouvrent la section #avis dans une fenêtre :
     son contenu y est déplacé (le widget Vitals garde ses scripts), puis remis en place à la fermeture. */
  var dlg = null, dlgPlace = null, dlgSrc = null;
  function fermerAvis() { if (dlg && dlg.open) dlg.close(); }
  function rendreAvis() {
    if (!dlgSrc || !dlgPlace) return;
    var body = $('.hvp-dlg__b', dlg);
    var v = $('[data-hvp-vitals]', body); if (v && v.classList.contains('hvp-vitals--clip')) v.classList.remove('on');
    var m = $('[data-hvp-vitals-more]', body); if (m) m.parentNode.hidden = false;
    while (body.firstChild) dlgSrc.insertBefore(body.firstChild, dlgPlace);
    dlgPlace.remove(); dlgPlace = null;
    dlgSrc.style.minHeight = '';
    D.documentElement.classList.remove('hvp-dlg-on');
    dlgSrc = null;
  }
  function ouvrirAvis(versTout) {
    var sec = D.getElementById('avis'), wrap = sec && $('.hv-wrap', sec);
    if (!wrap || !window.HTMLDialogElement) return false;
    if (!dlg) {
      dlg = D.createElement('dialog'); dlg.className = 'hvp-dlg'; dlg.setAttribute('aria-labelledby', 'hvp-dlg-t');
      var t = ($('h2', wrap) || {}).textContent || 'Avis';
      dlg.innerHTML = '<div class="hvp-dlg__h"><p class="hvp-dlg__t" id="hvp-dlg-t"></p><button type="button" class="hvp-dlg__x" data-hvp-dlg-x aria-label="Fermer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="hvp-dlg__b"></div>';
      $('.hvp-dlg__t', dlg).textContent = t.trim();
      D.body.appendChild(dlg);
      dlg.addEventListener('close', rendreAvis);
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-hvp-dlg-x]')) fermerAvis(); });
    }
    if (dlg.open) return true;
    dlgSrc = wrap; dlgSrc.style.minHeight = wrap.offsetHeight + 'px';
    dlgPlace = D.createComment('avis');
    wrap.insertBefore(dlgPlace, wrap.firstChild);
    var body = $('.hvp-dlg__b', dlg);
    Array.prototype.slice.call(wrap.childNodes).forEach(function (n) { if (n !== dlgPlace) body.appendChild(n); });
    $$('.hv-rv, .hv-rv-fade, [data-hv-reveal]', body).forEach(function (x) { x.classList.add('vu'); });
    var v = $('[data-hvp-vitals]', body); if (v) v.classList.add('on');
    var m = $('[data-hvp-vitals-more]', body); if (m) m.parentNode.hidden = true;
    D.documentElement.classList.add('hvp-dlg-on');
    dlg.showModal();
    body.scrollTop = 0;
    if (versTout) { var tv = $('[data-hvp-vitals]', body); if (tv) body.scrollTop = tv.offsetTop - 12; }
    return true;
  }
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hvp-avis-open], [data-hvp-vitals-more]');
    if (!a || (dlg && dlg.contains(a))) return;
    if (ouvrirAvis(a.hasAttribute('data-hvp-vitals-more'))) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ---------- défilement doux vers les ancres internes ---------- */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-hvp-scroll]'); if (!a) return;
    var h = a.getAttribute('href'); if (!h || h.charAt(0) !== '#') return;
    var t = D.getElementById(h.slice(1)); if (!t) return;
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.pageYOffset - ((parseInt(getComputedStyle(D.documentElement).getPropertyValue('--hv-hd-h'), 10) || 64) + 12);
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  });

  function init(c) {
    c = c || D;
    $$('[data-hvp]', c).forEach(fiche);
    $$('[data-hvp-gal]', c).forEach(galerie);
    $$('[data-hvp-ship]', c).forEach(dates);
    $$('[data-hvp-deck]', c).forEach(paquet);
    $$('[data-hvp-book]', c).forEach(livre);
    $$('[data-hvp-ba-anim]', c).forEach(bienfaits);
    $$('[data-hvp-reviews]', c).forEach(avis);
    $$('[data-hvp-faq]', c).forEach(function (s) { onglets(s, 'data-hvp-ftab', 'faq'); });
    $$('[data-hvp-related]', c).forEach(function (s) { onglets(s, 'data-hvp-xtab', 'x'); });
    $$('[data-hvp-reco]', c).forEach(reco);
    videos(c);
  }
  window.HoverProduit = { init: init };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
